import { getAddons } from '../../../global/pricingConfig';
import {
  planSelectionStoreSelector,
  usePlanSelectionStore,
} from '../../../stores/planSelectionStore';
import { PricingPlanAddon } from '../../../types/Pricing';

const useSelectedAddon = (): PricingPlanAddon | null => {
  const expertAddonId = usePlanSelectionStore(
    planSelectionStoreSelector.expertAddonPriceId
  );
  const addons = getAddons()!;

  return addons.find(({ stripeId }) => stripeId === expertAddonId) ?? null;
};

export default useSelectedAddon;
